import { notification } from 'antd';
export const checkURLReg =
	/^((http(s?):\/\/)?([wW]{3}\.)?[a-zA-Z0-9\-.]+((:\d+)|(\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?)))(\/[a-zA-Z0-9_\-.]*)*(\?[a-zA-Z0-9_&=]*)?$/;

export const displayFormats = {
	DATE_FORMAT: 'DD-MM-YYYY',
	TIME_FORMAT: 'HH:mm:ss',
	DATE_TIME_FORMAT: 'DD-MM-YYYY HH:mm',
};

export const Notification = {
	success: (data) => {
		notification.success({
			placement: data.placement ? data.placement : 'bottomRight',
			duration: 3,
			...data,
		});
	},
	error: (data) => {
		notification.error({
			placement: data.placement ? data.placement : 'bottomRight',
			duration: 3,
			...data,
		});
	},
	info: (data) => {
		notification.info({
			placement: data.placement ? data.placement : 'bottomRight',
			duration: 3,
			...data,
		});
	},
};

export const convertFileToBase64 = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file.originFileObj);
		reader.onload = () => resolve(reader.result.split(',')[1]); // Split to remove data URL scheme
		reader.onerror = (error) => reject(error);
	});
};

export const popularityType = [
	{
		value: 1,
		text: 'Popularity',
	},
	{
		value: 2,
		text: 'Most Popularity',
	},
];

export const FileDetailType = {
	Temple: 1,
	Accommodation: 2,
};

export const RegionType = {
	Country: 1,
	State: 2,
	District: 3,
	City: 4,
	Village: 5,
};

export const FileStatusType = ['In Progress', 'Failed', 'Succeeded'];

export const ImageType = [
	{ value: 1, text: 'Logo' },
	{ value: 2, text: 'Banner' },
	{ value: 3, text: 'Property' },
];

export const templeOriginalHeaderArr = [
	'Sr.No.',
	'TempleName',
	'SearchKeywords',
	'ShortName',
	'Description',
	'Address',
	'CityName',
	'StateName',
	'PinCode',
	// 'Popularity',
	'HowtoReach',
	'Cameraallowed',
	'NearByPlaces',
	'TempleWebSite',
	'IsLivedarshan',
	'LiveDarshanUrl',
	'BestTimeToVisit',
	'Remarks',
	'TimingType',
	'TimeDescription',
	'FromTime',
	'ToTime',
];
export const accommodationOriginalHeaderArr = [
	'Sr.No.',
	'PropertyName',
	'Description',
	'Address',
	'StateName',
	'CityName',
	'PinCode',
	'ContactNo',
	'PropertyType',
	'CheckIn',
	'CheckOut',
	'PropertyAmenity',
	'RoomType',
	'RoomTitle',
	'NoOfRooms',
	'NoOfBed',
	'AdditionalBedCapaCity',
	'MaxGuest',
	'RoomAmenity',
	'PropertyWebSite',
	'TempleName',
	'DistanceFromTemple',
	'Location',
	'MerchentShortName',
];
export const templeSteps = [
	{
		title: 'Basic Details',
	},
	{
		title: 'Darshan Timing',
	},
	{
		title: 'Image Upload Details',
	},
];

export const accommodationSteps = [
	{
		title: 'Merchant Details',
	},
	{
		title: 'Merchant Subscription',
	},
	{
		title: 'Accommodation Details',
	},
	// {
	// 	title: 'Room Category Details',
	// },
];
export const PropertySteps = [
	{
		title: 'Property Details',
	},
	{
		title: 'Property Image',
	},
	{
		title: 'Room Category Details',
	},
	{
		title: 'Room Category Image',
	},
];
export const convertExcelTimeToAMPM = (excelTime) => {
	if (typeof excelTime === 'number') {
		const hours = Math.floor(excelTime * 24);
		const minutes = Math.round((excelTime * 24 - hours) * 60);
		const period = hours >= 12 ? 'PM' : 'AM';
		const formattedHours = hours % 12 || 12; // Convert 24-hour time to 12-hour
		return `${formattedHours}:${minutes.toString().padStart(2, '0')} ${period}`;
	}
	return excelTime;
};

export const convertToWebP = async (input) => {
	return new Promise((resolve, reject) => {
		if (input.type.startsWith('video/')) {
			// Skip conversion for video files
			return resolve(input);
		}
		const img = new Image();
		const reader = new FileReader();
		reader.onload = e => {
			img.src = e.target?.result;
		};
		img.onload = () => {
			const canvas = document.createElement("canvas");
			canvas.width = img.width;
			canvas.height = img.height;
			const ctx = canvas.getContext("2d");
			if (!ctx) return reject("Canvas error");
			ctx.drawImage(img, 0, 0);
			canvas.toBlob(
				(blob) => {
					if (!blob) return reject("Conversion failed");
					const name = input.name || "image";
					const webpFile = new File(
						[blob],
						name.replace(/\.[^/.]+$/, ".webp"),
						{ type: "image/webp" }
					);
					resolve(webpFile);
				},
				"image/webp",
				0.9
			);
		};
		img.onerror = reject;
		reader.readAsDataURL(input);
	});
};